import { render, staticRenderFns } from "./BalanceSection.vue?vue&type=template&id=77e0cf96&scoped=true"
import script from "./BalanceSection.vue?vue&type=script&lang=js"
export * from "./BalanceSection.vue?vue&type=script&lang=js"
import style0 from "./BalanceSection.vue?vue&type=style&index=0&id=77e0cf96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e0cf96",
  null
  
)

export default component.exports